import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { FontFaces, Link } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';
import { useParsedStory } from '@micromag/core/hooks';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

// import Authors from '../partials/Authors';
import { isTouchDevice } from '../../lib/utils';

import SettingsButton from '../buttons/Settings';
import StoryMenu from '../menus/Story';
import ScreenItem from './Screen';

import styles from '../../../styles/items/story.module.scss';

const propTypes = {
    item: MicromagPropTypes.story.isRequired,
    link: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    link: null,
    className: null,
};

const StoryItem = ({ item, link, className }) => {
    const url = useUrlGenerator();
    const { components: screens = [], fonts = null } = useParsedStory(item);
    const finalFonts = useMemo(() => fonts || [], [fonts]);

    const screensCount = screens.length;
    const screen = screensCount > 0 ? screens[0] : null;

    const touchDevice = isTouchDevice();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isMouseDevice]: !touchDevice,
                },
            ])}
        >
            <FontFaces fonts={finalFonts} />
            <div className={classNames(['rounded', 'bg-dark', styles.screen])}>
                <Link
                    href={url(link, {
                        story: item.id,
                    })}
                    className={classNames([styles.link])}
                >
                    <strong
                        className={classNames([
                            'card-title',
                            'text-white',
                            'p-2',
                            'mb-auto',
                            'mt-0',
                            styles.title,
                        ])}
                    >
                        {item.title}
                    </strong>
                </Link>
                {screen !== null ? (
                    <ScreenItem item={screen} className={classNames([styles.preview])} />
                ) : null}
            </div>
            <div className={classNames([styles.top, 'p-2'])}>
                <SettingsButton
                    theme="light"
                    iconOnly
                    size="sm"
                    buttonClassName="py-1 px-2"
                    dropdown={
                        <StoryMenu
                            className={styles.menu}
                            story={item}
                            asDropdown
                            withoutDropdown
                            withDuplicate
                            withDelete
                            withoutBackToScreens
                        />
                    }
                />
            </div>
        </div>
    );
};

StoryItem.defaultProps = defaultProps;
StoryItem.propTypes = propTypes;

export default StoryItem;
